var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.3057C24 11.3191 23.9183 10.5991 23.7415 9.85242H12.2449V14.3057H18.9932C18.8572 15.4124 18.1225 17.0791 16.4898 18.199L16.4669 18.3481L20.1019 21.1078L20.3537 21.1324C22.6666 19.0391 24 15.959 24 12.3057Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2452 24.0391C15.5513 24.0391 18.3268 22.9724 20.354 21.1325L16.4901 18.1991C15.4561 18.9057 14.0683 19.3991 12.2452 19.3991C9.00717 19.3991 6.2589 17.3058 5.27921 14.4125L5.13561 14.4244L1.35589 17.2911L1.30646 17.4258C3.32004 21.3457 7.45609 24.0391 12.2452 24.0391Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27884 14.4124C5.02035 13.6658 4.87074 12.8657 4.87074 12.0391C4.87074 11.2124 5.02035 10.4124 5.26524 9.66574L5.2584 9.50672L1.4313 6.59399L1.30609 6.65236C0.476194 8.27905 0 10.1058 0 12.0391C0 13.9724 0.476194 15.799 1.30609 17.4257L5.27884 14.4124Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2452 4.67903C14.5445 4.67903 16.0955 5.65236 16.9799 6.46575L20.4356 3.15906C18.3133 1.22573 15.5513 0.0390625 12.2452 0.0390625C7.45609 0.0390625 3.32004 2.73238 1.30646 6.65235L5.26561 9.66572C6.2589 6.77239 9.00717 4.67903 12.2452 4.67903Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo-google.504003c1414b24184d6a94d5c286196f.svg";
export { ForwardRef as ReactComponent };